export default {
  home: {
    header: {
      title: 'CAT4MRO',
      supplier: {
        subtitle_1: 'Permite exponer sus <b>ítems directamente</b> a los <b>compradores</b> de la minería.',
        subtitle_2: 'En <b>CAT4MRO</b>, para cada <b>necesidad</b> de compra levantada por un comprador con <b>características técnicas</b> similares a algún ítem de su catálogo, su oferta se desplegará <b>automáticamente</b>.',
      },
      buyer: {
        subtitle_1: '<b>CAT4MRO toma</b> la <b>necesidad</b> de compra levantada por los compradores y las compara contra los catálogos de proveedores. <b>Como resultado CAT4MRO entrega la lista de proveedores  con ítems con alta coincidencias a nivel de especificación técnica.</b>',
      },
    },
    body: {
      sections: {
        title: 'Beneficios',
        supplier: {
          cards_1: 'Visibilidad de tus <strong>ítems </strong>directamente en el origen de la <strong>demanda</strong>',
          cards_2: 'Conoce qué empresas están buscando <strong>ítems </strong>de tu <strong>catálogo&nbsp;</strong>',
          cards_3: 'Ranking de <strong>categorías </strong>e<strong>ítems </strong>más buscados',
          cards_4: 'Consulta por <strong>industria </strong>qué <strong>ítems </strong>de tu catálogo son los <strong>más requeridos</strong>',
          cards_5: 'Conoce la <strong>demanda </strong>de tus <strong>ítems </strong>por <strong>zona geográfica</strong>',
          cards_6: 'Menores <strong>costos </strong>de <strong>contacto </strong>y <strong>transacción</strong>',
        },
        buyer: {
          cards_1: 'CAT4MRO permite encontrar fácil y rápidamente proveedores, productos o servicios basados en la descripción del ítem',
          cards_2: 'CAT4MRO tiene más de 1.700 catálogos de distintos proveedores, con más de 1,2 millones de ítems',
          cards_3: 'Más de 300 distintas categorías de materiales y servicios disponibles',
          cards_4: 'Motor de búsqueda inteligente basado en las especificaciones técnicas de los materiales o servicios',
          cards_5: 'Con CAT4MRO podrá darle trazabilidad a su proceso de búsqueda y selección de proveedores.',
          cards_6: 'Menores costos de contacto y transacción',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/home.js